<template>
  <div class="apply-enroll">
    <div class="info-steps" style="margin-bottom:20px">
      <!--enrollExamine enrollStatus null提交报名 0 审核中 1 报名成功 2审核不通过-->
      <el-steps
        :active="activeStep"
        align-center
        v-if="applyEnrollForm.enrollExamine == 1"
      >
        <el-step title="提交报名"></el-step>
        <el-step title="资格审核"></el-step>
        <el-step
          :title="
            applyEnrollForm.enrollStatus === 2 ? '审核不通过' : '报名成功'
          "
        ></el-step>
      </el-steps>
      <el-steps :active="activeStep" align-center v-else>
        <el-step title="提交报名"></el-step>
        <el-step
          title="
            报名成功
          "
        ></el-step>
      </el-steps>
    </div>
    <el-divider></el-divider>
    <div class="apply-enroll-body">
      <el-form
        ref="applyEnrollForm"
        label-position="right"
        :rules="applyEnroll"
        label-width="190px"
        :model="applyEnrollForm"
        label-suffix=":"
      >
        <div class="readonly">
          <div style="padding-left: 30px;font-weight: 700;font-size:18px">
            公告基本信息
          </div>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item label="公告编号"
                ><span>{{ applyEnrollForm.code }}</span></el-form-item
              >
            </el-col>
            <el-col :span="12">
              <el-form-item label="距截止报名">
                <!--{{'报名截止时间-系统时间' }}-->
                <count-down
                  :type="1"
                  :startTime="applyEnrollForm.systemDate"
                  :endTime="applyEnrollForm.enrollEndTime"
                ></count-down>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="公告标题"
            ><span>{{ applyEnrollForm.title }}</span></el-form-item
          >
          <el-form-item label="公告发布单位">{{
            applyEnrollForm.publicCompName
          }}</el-form-item>
          <el-form-item label="购买资格审核">{{
            enrollExamine[applyEnrollForm.enrollExamine] || ''
          }}</el-form-item>
          <el-form-item label="本场竞买须知">
            <span
              style="color:red;word-wrap: break-word"
              v-html="applyEnrollForm.instructions"
            ></span>
          </el-form-item>
          <div v-if="!pageType">
            <div style="padding:30px;font-weight: 700;">看货信息</div>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="看货开始时间">{{
                  applyEnrollForm.inspectStartTime
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="距截止看货"
                  ><count-down
                    :type="1"
                    :startTime="applyEnrollForm.systemDate"
                    :endTime="applyEnrollForm.inspectEndTime"
                  ></count-down
                ></el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="看货截止时间">{{
              applyEnrollForm.inspectEndTime
            }}</el-form-item>
            <el-form-item label="看货地点">{{
              applyEnrollForm.inspectAddress
            }}</el-form-item>
            <el-form-item label="看货说明">{{
              applyEnrollForm.inspectReamrk
            }}</el-form-item>
          </div>
        </div>
        <div>
          <div
            style="padding-left: 30px;font-weight: 700;padding-top:30px;font-size:18px"
          >
            报名信息
          </div>
          <el-divider></el-divider>
          <el-row v-if="applyEnrollForm.jointWhetherFlag == 1">
            <el-form-item label="是否联合体" prop="jointWhether">
              <el-radio-group
                v-model="applyEnrollForm.jointWhether"
                v-if="!pageType"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
              <span v-else>{{
                applyEnrollForm.jointWhether == 1 ? '是' : '否'
              }}</span>
            </el-form-item>
            <el-form-item
              label="联合公司名称"
              prop="jointCompName"
              v-if="applyEnrollForm.jointWhether == 1"
            >
              <el-input
                v-if="!pageType"
                style="width:369px"
                v-model="applyEnrollForm.jointCompName"
                placeholder="请输入公司全称"
              >
              </el-input>
              <span v-else>{{ applyEnrollForm.jointCompName }}</span>
            </el-form-item>
          </el-row>
          <el-row v-if="applyEnrollForm.enrollExamine == 1">
            <el-col :offset="3" :span="18">
              <el-table
                border
                :data="applyEnrollForm.licenceList"
                style="margin-bottom:20px"
              >
                <el-table-column label="序号" type="index" width="50">
                </el-table-column>
                <!-- <el-table-column
                  label="证照类型"
                  prop="licenceTypeName"
                ></el-table-column> -->
                <el-table-column label="证照名称" prop="licenceName">
                  <template v-slot="scope">
                    <span
                      class="cell-link"
                      @click="onAddLicence(scope.row, scope.$index)"
                      >{{ scope.row.licenceName }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="证照有效期至"
                  prop="licenceEndTime"
                  align="center"
                  width="200px"
                >
                  <template v-slot="scope">
                    {{
                      scope.row.isLongValid == 1
                        ? '长期有效'
                        : scope.row.licenceEndTime
                    }}</template
                  ></el-table-column
                >
                <el-table-column
                  label="附件"
                  prop="licenceEndTime"
                  align="center"
                  width="200px"
                >
                  <template v-slot="scope">
                    <span
                      style="cursor: pointer;color:#427bd4"
                      @click="fileDown(scope.row)"
                      >{{ scope.row.fileName }}</span
                    >
                  </template></el-table-column
                >
                <el-table-column
                  label="操作"
                  prop="prop"
                  width="100px"
                  align="center"
                >
                  <template v-slot="scope">
                    <el-button
                      type="text"
                      @click="onAddLicence(scope.row, scope.$index)"
                    >
                      <span v-if="pageType || scope.row.licenceFrom == 1"
                        >查看</span
                      ><span v-else>上传</span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-row v-if="applyEnrollForm.enrollExamine == 1">
            <el-col :span="23">
              <el-form-item label="说明">
                <el-input
                  v-if="!pageType"
                  type="textarea"
                  v-model="applyEnrollForm.remark"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                ></el-input>
                <span v-if="pageType">{{ applyEnrollForm.remark }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <on-Upload
            v-if="applyEnrollForm.enrollExamine == 1"
            labelWidth="190px"
            :checkFlag="$route.query.pageType == 'check'"
            @fileDataSingle="fileDataSingle"
            :fileList="fileList"
            :warn="false"
          >
            <span class="title-type" v-if="!pageType"
              >补充上传其他报名附件(允许文件类型:
              .doc、.docx、.txt、.xls、.xlsx、.pdf、.jpeg、.jpg、.png、.bmp、.rar、.zip)</span
            >
          </on-Upload>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contName">
                <el-input
                  v-if="!pageType"
                  v-model="applyEnrollForm.contName"
                ></el-input>
                <span v-else>{{ applyEnrollForm.contName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机" prop="contMobile">
                <template slot="label">
                  手机号
                  <el-tooltip effect="light" placement="top-start">
                    <template slot="content">
                      在业务过程中接收系统短信提醒
                    </template>
                    <i class="el-icon-question table-worming">&nbsp;</i>
                  </el-tooltip>
                  :
                </template>
                <el-input
                  v-if="!pageType"
                  v-model="applyEnrollForm.contMobile"
                  placeholder="请输入常用手机号"
                ></el-input>
                <span v-else>{{ applyEnrollForm.contMobile }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="contEmail">
                <el-input
                  v-if="!pageType"
                  v-model="applyEnrollForm.contEmail"
                ></el-input>
                <span v-else>{{ applyEnrollForm.contEmail }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="contPhone">
                <el-input
                  v-if="!pageType"
                  v-model="applyEnrollForm.contPhone"
                ></el-input>
                <span v-else>{{ applyEnrollForm.contPhone }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="传真" prop="contFax">
                <el-input
                  v-if="!pageType"
                  v-model="applyEnrollForm.contFax"
                ></el-input>
                <span v-else>{{ applyEnrollForm.contFax }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="其他联系方式" prop="contOtherWay">
                <el-input
                  v-if="!pageType"
                  v-model="applyEnrollForm.contOtherWay"
                ></el-input>
                <span v-else>{{ applyEnrollForm.contOtherWay }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-checkbox
          v-model="checked"
          style="margin-bottom:20px;margin-top:18px;margin-right:14px;margin-left:80px"
          v-if="!pageType"
        ></el-checkbox>

        <!-- <span >我已阅读<p style="color:#427bd4;cursor:pointer;display:inline-block;" @click="getRuleHref()">《专区运营规则》</p>、<span style="color:#427bd4;cursor: pointer;">《竞买须知》</span>并完全理解、同意和承诺遵守相关内容要求。</span> -->
        <el-checkbox
          v-model="checkedflag"
          style="margin-bottom:20px;margin-top:18px;margin-right:14px;margin-left:80px"
          disabled
          v-if="pageType"
        ></el-checkbox>

        <div style="display:inline-block;margin-top:20px">
          我已阅读
          <p
            style="color:#427bd4;cursor:pointer;display:inline-block;"
            @click="getRuleHref()"
          >
            《专区运营规则》
          </p>
          、<span
            style="color:#427bd4;cursor: pointer;"
            @click="dialogVisibletruc = true"
            >《竞买须知》</span
          >并完全理解、同意和承诺遵守相关内容要求。
        </div>
        <div v-if="$route.query.pageType != 'check'">
          <div
            style="padding-left: 30px;font-weight: 700;font-size:18px;padding-top:30px"
          >
            现场看货
          </div>
          <el-divider></el-divider>

          <el-form-item label="是否现场看货" prop="surveyWhether">
            <el-radio-group v-model="applyEnrollForm.surveyWhether">
              <el-radio :label="1" :disabled="inspectFlag">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <span
              style="display:inline-block;padding-left:30px;color:#d9001b"
              v-if="inspectFlag"
              ><i class="el-icon-warning-outline"></i> 预约看货时间已截止</span
            >
          </el-form-item>
          <div v-if="applyEnrollForm.surveyWhether == 1 && inspectWhether == 1">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="预约看货时间"
                  prop="dInspect.inspectApplyTime"
                >
                  <el-date-picker
                    style="width:230px"
                    v-model="applyEnrollForm.dInspect.inspectApplyTime"
                    :picker-options="pickerOptionsApplyTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    default-time="9:00:00"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约看货人数">
                  <el-input
                    v-digits-limit="[10, 0]"
                    v-model.number="applyEnrollForm.dInspect.inspectApplyNum"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="23">
                <el-form-item label="预约说明">
                  <el-input
                    v-if="!pageType"
                    type="textarea"
                    v-model="applyEnrollForm.dInspect.inspectApplyRemark"
                    :rows="3"
                    maxlength="500"
                    show-word-limit
                  ></el-input>
                  <span v-if="pageType">{{
                    applyEnrollForm.dInspect.inspectApplyRemark
                  }}</span>
                </el-form-item>
              </el-col></el-row
            >

            <el-row>
              <el-col :span="12">
                <el-form-item label="联系人" prop="dInspect.contName">
                  <el-input
                    v-if="!pageType"
                    v-model="applyEnrollForm.dInspect.contName"
                  ></el-input>
                  <span v-else>{{ applyEnrollForm.dInspect.contName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机" prop="dInspect.contMobile">
                  <template slot="label">
                    手机号
                    <el-tooltip effect="light" placement="top-start">
                      <template slot="content">
                        在业务过程中接收系统短信提醒
                      </template>
                      <i class="el-icon-question table-worming">&nbsp;</i>
                    </el-tooltip>
                    :
                  </template>
                  <el-input
                    v-if="!pageType"
                    v-model="applyEnrollForm.dInspect.contMobile"
                    placeholder="请输入常用手机号"
                  ></el-input>
                  <span v-else>{{ applyEnrollForm.dInspect.contMobile }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱" prop="dInspect.contEmail">
                  <el-input
                    v-if="!pageType"
                    v-model="applyEnrollForm.dInspect.contEmail"
                  ></el-input>
                  <span v-else>{{ applyEnrollForm.dInspect.contEmail }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话" prop="dInspect.contPhone">
                  <el-input
                    v-if="!pageType"
                    v-model="applyEnrollForm.dInspect.contPhone"
                  ></el-input>
                  <span v-else>{{ applyEnrollForm.dInspect.contPhone }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="传真" prop="dInspect.contFax">
                  <el-input
                    v-if="!pageType"
                    v-model="applyEnrollForm.dInspect.contFax"
                  ></el-input>
                  <span v-else>{{ applyEnrollForm.dInspect.contFax }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="其他联系方式" prop="dInspect.contOtherWay">
                  <el-input
                    v-if="!pageType"
                    v-model="applyEnrollForm.dInspect.contOtherWay"
                  ></el-input>
                  <span v-else>{{
                    applyEnrollForm.dInspect.contOtherWay
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="applyEnrollForm.surveyWhether === 0">
            <on-Upload
              @fileDataSingle="noticeFiles"
              :fileList="applyEnrollForm.abandonSurveyFileList"
              labelWidth="190px"
              labelName="放弃现场踏勘承诺函"
              :required="true"
              :warn="false"
            ></on-Upload>
            <el-form-item>
              <div @click="getHref('放弃踏勘承诺函')" class="cell-link">
                放弃现场踏勘承诺函模板.docx
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-if="applyEnrollForm.enrollExamine && pageType">
          <div
            style="padding-left: 30px;font-weight: 700;font-size:18px;padding-top:30px"
          >
            审核信息
          </div>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="10">
              <el-form-item label="审批结果" prop="">
                <!--            0 审核中 1 报名成功 2审核不通过-->

                <span>{{
                  applyEnrollForm.enrollStatus == 0
                    ? '审核中'
                    : applyEnrollForm.enrollStatus == 1
                    ? '报名成功'
                    : '审核不通过'
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                v-if="!applyEnrollForm.enrollStatus == 0"
                label="审批时间"
                prop=""
              >
                <span>{{ applyEnrollForm.auditTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                v-if="!applyEnrollForm.enrollStatus == 0"
                label="审核说明"
                prop=""
              >
                <span>{{ applyEnrollForm.auditRemark }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                v-if="!applyEnrollForm.enrollStatus == 0"
                label="审核附件"
                prop=""
              >
                <div
                  v-for="item in auditFileList"
                  :key="item.fileId"
                  class="file-list"
                >
                  <a class="protocol-File-list" @click="auditFileDown(item)">{{
                    item.fileName
                  }}</a>
                  <!-- {{ item.fileName }} -->
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="footer-btn">
          <span v-if="!pageType">
            <el-button type="primary" @click="onSaveApplyInfo">确定</el-button>
            <el-button type="plain" @click="onResetApplyInfo('applyEnrollForm')"
              >取消</el-button
            >
          </span>
          <span v-if="pageType">
            <el-button
              type="primary"
              @click="reApplyDetail"
              v-if="
                applyEnrollForm.enrollStatus === 2 &&
                  applyEnrollForm.systemDate < applyEnrollForm.enrollEndTime
              "
              >重新报名</el-button
            >
            <el-button type="primary" @click="onBackDetail">关闭</el-button>
          </span>
        </div>
      </el-form>
    </div>
    <el-dialog title="竞买须知" :visible.sync="dialogVisibletruc" width="80%">
      <div
        style="line-height:20px; height: 400px;
            overflow: auto;"
      >
        <BiddingAnnouncements
          :type="baseInfolist.entrustWhether == 1 ? 'serviceProvider' : ''"
          :entrustChargeRate="baseInfolist.entrustChargeRate"
          :specialChargeRate="applyEnrollForm.specialChargeRate"
        />
        <p class="deal-info-text special">
          本场竞买须知：
        </p>
        <p class="our special" v-html="applyEnrollForm.instructions"></p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibletruc = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="资质证照"
      :visible.sync="licenceDialogVisible"
      width="70%"
    >
      <div class="account-card-body">
        <el-form
          ref="detailForm"
          :model="detailForm"
          label-width="130px"
          :rules="detailFormRule"
          inline
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="证照名称：">
                <span>{{ detailForm.licenceName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
                <el-form-item
                  label="证照有效期至："
                  prop="licenceEndTime"
                  ref="licenceEndTime"
                  :rules="
                    detailForm.isLongValid == 1
                      ? { required: false }
                      : {
                          required: true,
                          message: '请选择',
                          trigger: 'blur'
                        }
                  "
                >
                  <el-date-picker
                    v-model="detailForm.licenceEndTime"
                    type="date"
                    :disabled="detailForm.isLongValid == 1 ? true : false"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    v-if="!pageType && !checkflag"
                  ></el-date-picker>
                  <span v-else>{{
                    detailForm.isLongValid == 1
                      ? '长期有效'
                      : detailForm.licenceEndTime
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="!pageType && !checkflag">
                <el-form-item>
                  <el-checkbox
                    v-model="detailForm.isLongValid"
                    :true-label="1"
                    false-label="0"
                    :disabled="detailForm.licenceEndTime ? true : false"
                    @change="chooseIsLongValid"
                    >长期有效</el-checkbox
                  >
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="licence-detail">
          <el-col>
            <el-upload
              class="upload-demo"
              action=""
              accept=".jpg, .jpeg, .png, .bmp"
              :http-request="httpRequest"
              :before-upload="beforeUpload"
              :show-file-list="false"
              v-if="!pageType && !checkflag"
            >
              <el-row>
                <el-col :span="24">
                  <el-button size="mini" type="primary">选择</el-button>
                </el-col>
              </el-row>
              <div slot="tip" class="el-upload__tip">
                <dl class="upload-tip">
                  <dt>上传提示：</dt>
                  <dd>1.图片文件大小限制 20MB</dd>
                  <dd>2.图片尺寸最大2000*2000像素，最小600*600像素</dd>
                  <dd>3.允许文件类型：jpg.jpeg.bmp.png</dd>
                  <dd>4.请上传原件彩色扫描正面图片</dd>
                </dl>
              </div>
            </el-upload>
            <div class="img-box">
              <img :src="detailForm.src" alt="" />
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <span v-if="!pageType && !checkflag"
          ><el-button
            type="primary"
            size="mini"
            :disabled="submitButtonDisabled ? false : true"
            @click="onSaveLince"
            >确定</el-button
          >
          <el-button size="mini" @click="onResetAdd('detailForm')"
            >取消</el-button
          ></span
        >
        <span v-else
          ><el-button size="mini" @click="onResetAdd('detailForm')"
            >关闭</el-button
          ></span
        >
      </span>
    </el-dialog>

    <!-- 支付保证金提示框 -->
    <el-dialog
      title="缴纳保证金"
      class="dep-dialog"
      :before-close="cancelPayDeposit"
      :visible.sync="deposit.dialog"
      width="500px"
    >
      <div class="tac">
        <p>{{ deposit.userName }}，您好，</p>
        <p>
          本次竞价需缴纳保证金{{ deposit.depositPrice | numberFormat(2) }}元。
        </p>
        <p>请在竞价之前缴纳保证金，否则无法参与竞价！</p>
      </div>
      <span slot="footer" class="dialog-footer tacc">
        <el-button type="primary" @click="toPayDeposit">去缴纳</el-button>
        <el-button @click="cancelPayDeposit">暂不缴纳</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/config'
// import onFile from '@/components/onFile.vue'
export default {
  name: 'ApplyEnrooll',
  // components: { onFile },
  props: {
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      baseInfolist: {},
      format:
        '<span>dd</span>天<span style="font-size:28px">hh</span>小时<span style="font-size:28px">mm</span>分<span>ss</span>秒',
      checkflag: false,
      detailFormIndex: '',
      licenseList: [],
      dialogVisibletruc: false,
      checkedflag: true,
      checked: false,
      uploadDialogVisible: false,
      staticUrl: config.STATIC_URL,
      // 报名状态
      enrollStatus: {
        // null: '提交报名',
        0: '审核中',
        1: '报名成功',
        2: '审核不通过'
      },
      // 购买资格审核（1是；0否）
      enrollExamine: {
        0: '无需审核',
        1: '需审核'
      },
      activeStep: 0,
      noticeId: '',
      enroollId: '',
      licenseLength: 0,
      isDialogPicker: false,
      isLongValid: false, //默认可选择长期有效
      applyEnrollForm: {
        abandonSurveyFileList: [],
        surveyWhether: '',
        businessLicenseVO: [],
        licenceList: [],
        contMobile: '',
        contPhone: '',
        jointWhether: '',
        jointWhetherFlag: '',
        jointCompName: '',
        contEmail: '',
        dInspect: {
          inspectApplyTime: '',
          inspectApplyRemark: '',
          contName: '',
          contFax: '',
          contPhone: '',
          contMobile: '',
          contEmail: '',
          contOtherWay: '',
          inspectApplyNum: ''
        },
        contName: '', //调试数据
        remark: ''
      },
      dInspect: {
        inspectApplyTime: '',
        inspectApplyRemark: '',
        contName: '',
        contFax: '',
        contPhone: '',
        contMobile: '',
        contEmail: '',
        contOtherWay: '',
        inspectApplyNum: ''
      },
      applyEnroll: {
        surveyWhether: [
          {
            required: true,
            message: '请选择是否现场看货',
            trigger: 'change'
          }
        ],
        jointWhether: [
          {
            required: true,
            message: '请选择是否联合体',
            trigger: 'change'
          }
        ],
        jointCompName: [
          {
            required: true,
            message: ' 请输入联合公司名称',
            trigger: 'blur'
          }
        ],
        dInspect: {
          inspectApplyTime: [
            {
              required: true,
              message: '请选择预约看货时间',
              trigger: 'blur'
            }
          ],
          contName: [
            {
              required: true,
              message: '请输入联系人',
              trigger: 'blur'
            }
          ],
          contMobile: [
            {
              required: true,
              pattern: /^1[0-9]{10}$/,
              message: '请输入正确的格式',
              trigger: 'blur'
            }
          ],
          contPhone: [
            {
              message: '请输入正确的格式',
              trigger: 'blur'
            }
          ],
          contEmail: [
            {
              required: true,
              type: 'email',
              message: '请输入正确的格式',
              trigger: 'blur'
            }
          ]
        },
        contName: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }
        ],
        contMobile: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: '请输入正确的格式',
            trigger: 'blur'
          }
        ],
        contPhone: [
          {
            message: '请输入正确的格式',
            trigger: 'blur'
          }
        ],
        contEmail: [
          {
            required: true,
            type: 'email',
            message: '请输入正确的格式',
            trigger: 'blur'
          }
        ]
      },

      //保存请求报名
      saveEnroollForm: {
        licenceList: [],
        contName: '', //调试数据
        contPhone: '',
        contMobile: ' ',
        contEmail: '',
        remark: ''
      },
      inspectFlag: false,
      inspectWhether: '',
      checkMyLinceVisible: false,
      licenceDialogVisible: false,
      chooseLicenceDialog: false,
      myLicenceList: [],
      multipleSelection: [],
      detailForm: {
        licenceName: '',
        licenceCode: '',
        licenceEndTime: '',
        isLongValid: false,
        fileId: null,
        licenceTypeCode: '',
        licenceTypeName: '',
        src: ''
      },
      file: {
        data: '',
        src: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      pickerOptionsApplyTime: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      detailFormRule: {},
      //查看证照
      checkForm: {},
      submitButtonDisabled: true,
      previewDialogVisible: false,
      fileUrl: {},
      fileList: [],
      auditFileList: [],
      token: '',
      deposit: {
        userName: '',
        dialog: false,
        depositPrice: ''
      },
      from: ''
    }
  },
  computed: {
    pageType() {
      return this.$route.query.pageType == 'check'
    }
  },
  watch: {},
  created() {
    // this.getToken()

    //截取noticeId
    this.from = this.$route.query.from
    this.noticeId = this.$route.query.noticeId
    this.enroollId = this.$route.query.enroollId
    if (
      this.$route.query.pageType == 'check' ||
      this.$route.query.pageType == 'anew'
    ) {
      if (this.$route.query.pageType == 'check') {
        this.applyEnroll = {}
      }
      this.checkEnroolData(this.enroollId)
    } else {
      this.getEnroollData(this.noticeId)
    }
    //详情页面

    // 获取保证金金额
    this.getDeposit(this.noticeId)
  },
  methods: {
    async getToken() {
      let obj = {
        tokenFlag: '0'
      }
      let data = await this.$api.common.getToken(obj)
      this.token = data
    },
    async getDeposit(id) {
      const data = await this.$api.notice.getNoticeBaseInfoItem(id)

      this.deposit.depositPrice = data.depositPrice
      this.inspectWhether = data.inspectWhether
      let loginInfo = await this.$api.common.loginInfo()
      this.deposit.userName = loginInfo.userName
      this.applyEnrollForm.instructions = data.instructions
      this.applyEnrollForm.publicCompName = data.publicCompName
      this.applyEnrollForm.specialChargeRate = data.specialChargeRate
      this.applyEnrollForm.code = data.code
      this.baseInfolist = data
    },
    //gsn资质证照
    async getEnroollData(id) {
      let data = await this.$api.enrooll.getEnroollData(id)
      this.applyEnrollForm = {
        ...this.applyEnrollForm,
        ...data,
        jointWhetherFlag: data.jointWhether,
        jointWhether: ''
      }
      this.applyEnrollForm.dInspect.contName = this.applyEnrollForm.contName
      this.applyEnrollForm.dInspect.contFax = this.applyEnrollForm.contFax
      this.applyEnrollForm.dInspect.contPhone = this.applyEnrollForm.contPhone
      this.applyEnrollForm.dInspect.contMobile = this.applyEnrollForm.contMobile
      this.applyEnrollForm.dInspect.contEmail = this.applyEnrollForm.contEmail
      this.applyEnrollForm.licenceList =
        this.applyEnrollForm.businessLicenseListVO || []
      this.pickerOptionsApplyTime = {
        disabledDate: time => {
          return this.disabledDate(time)
        }
      }
      this.supplierDetail()
      this.inspectFun()
    },
    async supplierDetail() {
      let data = await this.$api.enrooll.buyerContInfo()
      this.applyEnrollForm.contName = data.contName
      this.applyEnrollForm.contMobile = data.contMobile
      this.applyEnrollForm.contEmail = data.contEmail
      this.applyEnrollForm.contFax = data.contFax
      this.applyEnrollForm.contPhone = data.contPhone
      this.applyEnrollForm.dInspect.contName = this.applyEnrollForm.contName
      this.applyEnrollForm.dInspect.contFax = this.applyEnrollForm.contFax
      this.applyEnrollForm.dInspect.contPhone = this.applyEnrollForm.contPhone
      this.applyEnrollForm.dInspect.contMobile = this.applyEnrollForm.contMobile
      this.applyEnrollForm.dInspect.contEmail = this.applyEnrollForm.contEmail
    },
    inspectFun() {
      const a = new Date().getTime()
      const b = new Date(this.applyEnrollForm.inspectEndTime).getTime()
      if (a > b) {
        this.inspectFlag = true
        this.applyEnrollForm.surveyWhether = 0
      } else {
        this.inspectFlag = false
      }
    },
    // 时间选择 disable 属性
    disabledDate(time) {
      let systemDate =
        new Date(this.applyEnrollForm.systemDate).getTime() - 8.64e7
      let startInspect =
        new Date(this.applyEnrollForm.inspectStartTime).getTime() - 8.64e7
      let endInspect = new Date(this.applyEnrollForm.inspectEndTime).getTime()

      const startTime = Math.max(systemDate, startInspect)

      return time.getTime() < startTime || time.getTime() > endInspect
    },
    //公告资质证照
    async getNoticelicence(licenceList) {
      let data = await this.$api.enrooll.getNoticelicence(this.noticeId)

      this.applyEnrollForm.licenceList = licenceList.concat(data)
      console.log(this.applyEnrollForm.licenceList)
      this.$forceUpdate()
    },

    //查看报名
    async checkEnroolData(id) {
      let data = (await this.$api.enrooll.checkEnrooll(id)) || {}
      this.fileList = data.enroollFileList ? data.enroollFileList : []
      this.auditFileList = data.enroollAuditFileList
        ? data.enroollAuditFileList
        : []
      console.log(data)
      this.applyEnrollForm = {
        ...this.applyEnrollForm,
        ...data,
        jointWhetherFlag: data.noticeVO.jointWhether,
        title: (data.noticeVO || {}).title,
        systemDate: (data.noticeVO || {}).systemDate,
        enrollEndTime: (data.noticeVO || {}).enrollEndTime,
        requireRemark: (data.noticeVO || {}).requireRemark,
        enrollExamine: (data.noticeVO || {}).enrollExamine,
        licenceList: (data || {}).licenceList,
        inspectStartTime: data.noticeVO.inspectStartTime,
        inspectEndTime: data.noticeVO.inspectEndTime,
        inspectAddress: data.noticeVO.inspectAddress,
        dInspect: data.enroollInspectSimpleVO
          ? data.enroollInspectSimpleVO
          : this.applyEnrollForm.dInspect,
        abandonSurveyFileList: data.abandonSurveyFileList
          ? data.abandonSurveyFileList
          : []
      }
      console.log(this.applyEnrollForm)
      this.pickerOptionsApplyTime = {
        disabledDate: time => {
          return this.disabledDate(time)
        }
      }
      if (
        this.applyEnrollForm.abandonSurveyFileList &&
        this.applyEnrollForm.abandonSurveyFileList.length != 0
      ) {
        this.applyEnrollForm.abandonSurveyFileList.map(item => {
          item.name = item.fileName
        })
      }

      this.applyEnrollForm.licenceList.map(item => {
        if (item.isLongValid == 1) {
          item.licenceEndTime = ''
        }
      })
      if (this.fileList.length != 0) {
        this.fileList.map(item => {
          item.name = item.fileName
        })
      }
      // applyEnrollForm.enrollStatus == null?1:(applyEnrollForm.enrollStatus == 0?2:(applyEnrollForm.enrollStatus == 1?3:3))
      if (this.applyEnrollForm.enrollExamine) {
        // 需要审核
        if (this.applyEnrollForm.enrollStatus) {
          // 1 报名成功 或者 2 审核不通过,
          this.activeStep = 3
        } else if (this.applyEnrollForm.enrollStatus === 0) {
          this.activeStep = 2
        }
      } else if (this.applyEnrollForm.enrollStatus) {
        // 1 报名成功 或者 2 审核不通过,
        // 无需审核
        this.activeStep = 2
      }
      this.inspectFun()
    },
    //附件下载
    fileDown(val) {
      if (val.licenceFrom && val.licenceFrom == 1 && val.imageUrl) {
        window.open(val.imageUrl)
      } else {
        this.onDownload(val)
      }
    },
    fileDataSingle(val) {
      this.fileList = val
    },

    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    },
    getRuleHref() {
      return window.open(config.RULEURL, '_blank')
    },
    auditFileDown(val) {
      this.onDownload(val)
    },

    //选择是否长期
    chooseIsLongValid(val) {
      if (val == 1) {
        this.$refs.licenceEndTime.clearValidate()
      }
    },
    onAddLicence(row, index) {
      this.submitButtonDisabled = true //重复点击

      this.detailForm = JSON.parse(JSON.stringify(row))
      this.detailFormIndex = index

      if (row.licenceFrom && row.licenceFrom == 1 && row.imageUrl) {
        this.checkflag = true
        this.$set(this.detailForm, 'src', row.imageUrl)
        console.log(this.detailForm)
      } else {
        if (row.licenceFrom == 1) {
          this.checkflag = true
        } else {
          this.checkflag = false
        }

        if (row.imageUrl || row.fileWebpath) {
          this.$set(
            this.detailForm,
            'src',
            this.staticUrl +
              (this.detailForm.imageUrl || this.detailForm.fileWebpath)
          )
        }
      }
      this.licenceDialogVisible = true
    },
    getHref(val) {
      return window.open(`./${val}.docx`, '_blank')
    },
    //保存申请信息
    async onSaveApplyInfo() {
      if (
        this.applyEnrollForm.enrollExamine == 1 &&
        this.applyEnrollForm.licenceList.length != 0
      ) {
        let arr = this.applyEnrollForm.licenceList.filter(
          item => item.licenceFrom == 2
        )
        let licenceListflag = arr.every(
          item1 =>
            item1.fileId && (item1.isLongValid == 1 || item1.licenceEndTime)
        )
        if (!licenceListflag) {
          this.$message.error('请完善资质证照信息')
          return false
        }
      }
      if (this.applyEnrollForm.surveyWhether === 0) {
        if (
          !this.applyEnrollForm.abandonSurveyFileList ||
          this.applyEnrollForm.abandonSurveyFileList.length == 0
        ) {
          this.$message.error('请上传放弃现场踏勘承诺函')
          return false
        }
      }
      if (!this.checked) {
        this.$message.error('请确认是否阅读竞买须知')
        return false
      }
      let fileids = []
      this.fileList.forEach(item => {
        fileids.push(item.fileId)
      })
      this.$refs.applyEnrollForm.validate(async valid => {
        if (valid) {
          //向数据库上传
          this.applyEnrollForm.dInspect.noticeId = this.$route.query.noticeId

          let params = {
            contName: this.applyEnrollForm.contName,
            contPhone: this.applyEnrollForm.contPhone,
            contMobile: this.applyEnrollForm.contMobile,
            contEmail: this.applyEnrollForm.contEmail,
            contOtherWay: this.applyEnrollForm.contOtherWay,
            remark: this.applyEnrollForm.remark,
            noticeId: this.noticeId,
            contFax: this.applyEnrollForm.contFax,
            enrollExamine: this.applyEnrollForm.enrollExamine,
            enroollLicenceEditVOList: this.applyEnrollForm.licenceList,
            id: this.$route.query.enroollId || this.$route.query.noticeId,
            jointCompName:
              this.applyEnrollForm.jointWhether == 1
                ? this.applyEnrollForm.jointCompName
                : '',
            jointWhether: this.applyEnrollForm.jointWhether,
            fileId: fileids.join(','),
            token: this.token,
            dInspect: this.applyEnrollForm.dInspect,
            surveyWhether: this.applyEnrollForm.surveyWhether,
            abandonSurveyFileList:
              this.applyEnrollForm.surveyWhether == 1
                ? []
                : this.applyEnrollForm.abandonSurveyFileList
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let data = await this.$api.enrooll.saveEnrooll(params)
          if (data) {
            loading.close()
            this.$confirm(
              '网上发布的物资图片及其资料仅供参考。按照有关规定及“依物品现状进行竞价”的国际惯例，不应仅依赖图片及其资料对物资的状况做出判断，应在竞买前自行认真核实，查验竞买资源信息，自行判断所竞买物资现状是否符合其相关资料或描述，本平台及平台经营者不对废旧物资的型号、质量、可使用性做任何承诺，也不承担任何瑕疵担保责任。为避免您的损失，请务必现场查验，未查验物资现状参加竞买者责任自负，并愿承担一切法律责任。',
              '现场看货提醒',
              {
                confirmButtonText: '已知晓',

                showCancelButton: false
              }
            )
              .then(() => {
                // 判断保证金
                this.showDepoit()
              })
              .catch(() => {
                let path = '/home/noticeInfo'
                if (this.from) {
                  path = '/home/noticeSealInfo'
                }
                this.$router.push({
                  path: path,
                  query: {
                    id: this.$route.query.noticeId
                  }
                })
              })
          }
          loading.close()
          if (!data) return

          // this.$router.back(-1)
        }
      })

      // contName: '', //调试数据
    },
    // 显示保证金弹框
    showDepoit() {
      this.deposit.dialog = true
    },
    toPayDeposit() {
      this.deposit.dialog = false
      let query = {
        noticeId: this.noticeId
      }
      if (this.from) {
        query.from = 'noticeSealInfo'
      }
      this.$router.push({
        name: 'MyDepositOperate',
        query: query
      })
    },
    cancelPayDeposit() {
      let path = '/home/noticeInfo'
      if (this.from) {
        path = '/home/noticeSealInfo'
      }
      this.$router.push({
        path: path,
        query: {
          id: this.$route.query.noticeId
        }
      })
    },
    //取消申请
    onResetApplyInfo(ruleForm) {
      this.$refs[ruleForm].resetFields()
      let path = '/home/noticeInfo'
      if (this.from) {
        path = '/home/noticeSealInfo'
      }
      this.$router.push({
        path: path,
        query: {
          id: this.$route.query.noticeId
        }
      })
      // this.$router.back(-1)
    },
    //重新报名
    reApplyDetail() {
      let query = {
        noticeId: this.applyEnrollForm.noticeId,
        pageType: 'anew',
        enroollId: this.$route.query.enroollId
      }
      if (this.from) {
        query.from = this.from
      }
      this.$router.push({
        path: '/home/ApplyEnroollService',
        query: query
      })
      location.reload()
    },
    //返回详情
    onBackDetail() {
      this.$router.back(-1)
    },
    beforeUpload(file) {
      let reg = /\.(jpg|JPG|png|PNG|BMP|bmp|JPEG|jpeg)$/
      const isJPG = reg.test(file.name)
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isJPG) {
        this.$message.error('上传图片格式有误!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过20M!')
      }
      return isJPG && isLt2M
    },
    httpRequest(params) {
      // if (!this.beforeUpload) return
      console.log(params)
      let fileReader = new FileReader()
      fileReader.readAsDataURL(params.file)
      fileReader.onload = () => {
        let img = new Image()
        let src = fileReader.result
        img.src = src

        img.onload = async () => {
          let form = new FormData()
          form.append('file', params.file)
          let fileData = await this.$api.common.fileUpload(form)
          this.detailForm.fileId = fileData.fileId
          this.detailForm.fileName = fileData.fileName

          this.detailForm.imageUrl = fileData.fileWebpath
          this.detailForm.fileWebpath = fileData.fileWebpath
          this.$set(
            this.detailForm,
            'src',
            this.staticUrl + fileData.fileWebpath
          )
        }
      }
    },
    //保存弹窗中证照信息
    async onSaveLince() {
      this.$refs.detailForm.validate(async valid => {
        if (valid) {
          //向数据库上传
          if (!this.detailForm.fileId) {
            this.$message.error('请上传附件!')
            return
          } else {
            this.submitButtonDisabled = false
          }
          this.$set(
            this.applyEnrollForm.licenceList,
            this.detailFormIndex,
            this.detailForm
          )
          this.licenceDialogVisible = false
        }
      })
    },
    //取消证照选择
    onResetAdd(ruleForm) {
      this.$refs[ruleForm].resetFields()
      this.licenceDialogVisible = false
    },
    noticeFiles(val) {
      this.applyEnrollForm.abandonSurveyFileList = val
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep.apply-enroll {
  padding: 40px 0px;
  .file-list {
    a {
      color: #427bd4;
      cursor: pointer;
      line-height: 30px;
    }
  }
  .el-dialog__body {
    padding: 0 10px;
    min-height: 200px;
    .deposit-detail {
      .upload-tip {
        overflow: hidden;
        dt {
          float: left;
        }
        div {
          overflow: hidden;
          dd {
            float: left;
            margin-right: 6px;
          }
        }
      }
    }
    .deposit-price-title {
      text-align: center;
    }
  }
  .file-preview {
    padding: 10px;
    display: flex;
    justify-content: center;
    img {
      width: 100%;
    }
  }
  .img-box {
    display: flex;
    justify-content: center;
    margin: 10px 0;
    img {
      width: 100%;
    }
  }
  .licence-detail {
    .upload-tip {
      display: flex;
    }
  }
  .apply-enroll-body {
    .add-licence {
      margin: 20px 0 30px;
      text-align: right;
      .my-licence-choose {
        border-color: #febb0c;
      }
    }
    .section-card {
      border-top: 1px solid #dadada;
      .section-card-title {
        background: #fff;
      }
      .section-card-body {
        .require-remark {
          width: 100%;
          word-break: break-all;
          .el-form-item__content {
            width: 86%;
          }
        }
        .el-form-item__content {
          .el-textarea {
            width: 876px;
          }
        }
      }
    }
    .deposit-price-info {
      .info-title {
        padding-left: 31px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
.our {
  line-height: 30px;
}
.special {
  color: red;
  font-weight: bold;
}
.specialname {
  font-weight: bold;
}
.tac {
  text-align: left;
  line-height: 30px;
  font-weight: 500;
  font-size: 14px;
  padding-left: 50px;
}
.apply-enroll .dep-dialog .el-dialog__body {
  min-height: 140px;
}
.tacc {
  text-align: center;
  display: block;
}
.footer-btn {
  text-align: center;
}
::v-deep.readonly {
  .el-form-item {
    margin-bottom: 5px;
  }
}
::v-deep.el-input {
  width: 90%;
}
.title-type {
  position: absolute;
  left: 150px;
  top: 0;
  font-size: 13px;
}
</style>
